
  import { mapState } from 'vuex'
  import moment from 'moment'

  export default {
    data() {
      return {
        style: null,
        itemsUnavailable: false,
      }
    },
    async mounted() {
      // Apply promo code if it's set
      if (this.offerToApply) {
        const valid = await this.$api.addCoupon(this.offerToApply.cred.toUpperCase())
        if (valid) {
          this.$store.commit('setOfferToApply', null)
        }
      }

      // Check if any products are unavailable
      let productIds = []
      let unavailableProducts = []
      this.order.products.forEach(product => {
        productIds.push(product.product_id)
      })
      this.menu.categories.forEach(category => {
        category.products.forEach(product => {
          if (productIds.includes(product.id)) {
            if (!product.availability.now && this.order.time.mode == 'asap') {
              this.itemsUnavailable = true
            }
          }
        })
      })
    },
    mounted() {
      this.setStyle()
      window.addEventListener('scroll',this.setStyle)
      window.addEventListener('resize',this.setStyle)

      if (this.order && this.order.products && this.order.totals) {
        window.dataLayer = window.dataLayer || []
        window.dataLayer.push({
          'event': 'view_cart',
          ...this.getViewCartEventData()
        })
      }
      if (this.mobile) {
        document.querySelector('body').style.overflowY = 'hidden'
      }

      this.getOffers()
    },
    destroyed() {
      window.removeEventListener('scroll',this.setStyle)
      window.removeEventListener('resize',this.setStyle)
      // Remove style tag from body or set to overflow auto
      const body = document.querySelector('body')
      const styleText = body.textContent.trim()
      const cssRules = styleText.split(';')
      if (cssRules.length === 1 && cssRules[0].trim().startsWith('overflow-y')) {
        body.removeAttribute('style')
      } else {
        body.style.overflowY = 'auto'
      }
    },
    computed: {
      ...mapState(['headerHeight', 'order', 'walletOffers', 'menu', 'user', 'channel', 'handoffToggle', 'location']),
      mobile() {
        return (this.$mq == 'sm' || this.$mq == 'md')
      },
      deliveryFee() {
        return this.order.totals.handoff ? this.order.totals.handoff.toFixed(2) : '0.00'
      },
      isFreeDelivery() {
        return this.deliveryFee === '0.00' || this.deliveryFee === 0
      }
    },
    methods: {
      getViewCartEventData() {
        const eventItems = this.order.products.map((item, index) => {
          const category = this.menu.categories.find(c => c.products.find(p => p.name === item.name))
          const itemData = {
            'index': index,
            'item_id': item.id,
            'item_name': item.name,
            'price': item.cost.total,
            'quantity': item.quantity,
          }

          if (category) {
            itemData.item_list_id = category.id
            itemData.item_list_name = category.name
            itemData.item_category = category.name
          }

          return itemData
        })

        return {
          'ecommerce': {
            'affiliation': this.channel,
            'currency': 'USD',
            'price':  this.order.totals.subtotal,
            'location_name': this.location?.name,
            'location_code': this.location?.id,
            'items': eventItems,
          }
        }
      },
      setStyle() {
        // const position = window.scrollY || window.pageYOffset
        // if (position >= this.headerHeight.replace('px','')) {
        //   this.style = 'top:0px;position:fixed'
        // } else {
          this.style = 'top:'+this.headerHeight
        // }
      },
      checkout() {
        if (this.$route.path.includes('checkout')) {
          this.$store.commit('setShowCart', false)
        } else {
          this.$router.push('/order/checkout')
        }
      },
      async getOffers() {
        if (this.user) {
          try {
            const walletOffers = await this.$api.getWalletOffers()
            let offers = []
            walletOffers.rewards.forEach(offer => {
              const notExpired = !offer.expires || moment.utc(offer.expires).isSameOrAfter(moment.utc().startOf('day'))
              if (offer.status === 'incomplete' && notExpired) {
                offers.push(offer)
              }
            })
            if (this.channel === 'catering') {
              // Keep only catering offers
              offers = offers.filter(offer => /^catering - /i.test(offer.label))
              // Remove "Catering - " from label
              .map(offer => ({
                ...offer,
                label: offer.label.replace(/^catering - /i, '')
              }))
            } else {
              // Exclude catering offers
              offers = offers.filter(offer => !/^catering - /i.test(offer.label))
            }
            this.$store.commit('setWalletOffers', offers)
          } catch (error) {
            console.error(error)
          }
        }
      },
      addMoreItems() {
        this.$store.commit('setShowCart', false)
        if (this.$route.name !== 'order') {
          this.$router.push('/order')
        }
      }
    },
    watch: {
      '$route.path'(e) {
        this.$store.commit('setShowCart', false)
      }
    }
  }
